import { getAllOrcadoAnoNaoPrevisto } from '@app/api/naoPrevistos/parametros'
import { ETipoNaoPrevisto } from '@app/enums/ENaoPrevisto'
import { FormSelect, Row } from '@digital/ui'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { solicitacaoIdState, solicitacaoState } from '../../../atoms'
import { useRecoilState, useRecoilValue } from 'recoil'
import { isObjNotEmpty } from '@app/helpers/objHelper'

const StepDefinicaoTipoSolicitacao = () => {
    const solicitacaoId = useRecoilValue(solicitacaoIdState);
    const [options, setOptions] = useState([
        { value: moment().year(), text: moment().year() }
    ])

    useEffect(() => {
        const proximoAno = moment().add(1, 'year').year()
        getAllOrcadoAnoNaoPrevisto().then((data) => {
            if (data) {
                if (data.findIndex((item) => item.ano === proximoAno) >= 0) {
                    setOptions([
                        { value: moment().year(), text: moment().year() },
                        { value: proximoAno, text: proximoAno }
                    ])
                }
            }
        })
    }, [])

    return (
        <>
            <Row>
                <FormSelect
                    span={3}
                    name='ano'
                    defaultValue={moment().year()}
                    label='Ano'
                    options={options}
                    disabled={isObjNotEmpty(solicitacaoId)}
                />
            </Row>
            <Row>
                <FormSelect
                    span={3}
                    name='tipo'
                    label='Tipo'
                    options={[
                        { value: ETipoNaoPrevisto.CNP, text: 'CNP - Investimento (CapEx)' },
                        { value: ETipoNaoPrevisto.ONP, text: 'ONP - Conta Resultado/Fechamento de Mina' },
                    ]}
                />
            </Row>
        </>
    )
}

export default StepDefinicaoTipoSolicitacao